<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">用户名：</div>
                        <el-input v-model="userName" placeholder="请输入用户名"></el-input>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">操作日期：</div>
                        <el-date-picker v-model="operationTime" type="date" placeholder="请选择操作日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :span="6" :offset="4">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-dropdown @command="handleCommand">
                    <el-button type="primary">
                        选择导出数据时间段<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="3">近三天</el-dropdown-item>
                        <el-dropdown-item command="7">近七天</el-dropdown-item>
                        <el-dropdown-item command="15">近十五天</el-dropdown-item>
                        <el-dropdown-item command="30">近一个月</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="table"
                v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="10"
                @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import MultiExportFiles from '@/components/common/multiExportFiles'

import { queryLog } from '@/api/index';
import { formatDate, formatJson } from '@/utils/utils';
import { encrypt, decrypt } from '@/api/common_encrypt';

var that = null;
export default {
    data() {
        return {
            tableLoading: true,
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'modelName',
                    title: '功能模块'
                },
                {
                    key: 'subModelName',
                    title: '功能子模块'
                },
                {
                    key: 'operateName',
                    title: '操作类型'
                },
                {
                    key: 'userAccount',
                    title: '账号'
                },
                {
                    key: 'userName',
                    title: '用户名'
                },
                {
                    key: 'createTime',
                    title: '操作时间'
                },
                {
                    key: 'userIp',
                    title: '用户IP'
                },
            ],
            tableData: [],
            total: 0,
            addVisible: false,
            userName: '',
            exportVisible: false,
            operationTime: '',
            rangeDate: 3,
            currentPage: 1,
            pageSize: 10,
            tHeader: ['功能模块', '功能子模块', '操作类型', '账号', '用户名', '操作时间', '用户IP'],
            tValue: ['modelName', 'subModelName', 'operateName', 'userAccount', 'userName', 'createTime', 'userIp'],
            filename: '操作日志'
        }
    },
    components: {
        DyTable,
        MultiExportFiles
    },
    mounted() {
        that = this;
        that.getList();
    },
    methods: {
        // 重置
        resetList() {
            that.userName = '';
            that.operationTime = ''
            that.getList();
        },
        onCurrentChange(val) {
            that.currentPage = val
            that.getList()
        },
        // 导出
        handleCommand(type) {
            var query = {
                userName: '',
                rangeDate: type,
                needPage: false,
            };
            const queryData = encrypt(JSON.stringify(query))
            queryLog(queryData).then(resp => {
                var data = JSON.parse(decrypt(resp.data.replace(/[\r\n]/g, '')));
                that.levelList = data;
                import('@/components/ExportExcel/Export2Excel').then(excel => {
                    const data = formatJson(that.tValue, that.levelList);
                    excel.export_json_to_excel({
                        header: that.tHeader,
                        data,
                        filename: that.filename,
                        autoWidth: true,
                        bookType: 'xlsx'
                    });
                });
            }, () => {
                this.isloading = false
            })
        },
        //操作日志列表
        getList() {
            let info = {
                page: that.currentPage,
                pageSize: that.pageSize,
                userName: that.userName ? that.userName : '',
                createTime: that.operationTime,
                rangeDate: '',
                needPage: true,
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryLog(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('日志列表', ress);
                    that.total = ress.totalElements;
                    that.total = ress.totalElements;
                    that.tableData = ress.content.map(item => {
                        return {
                            ...item,
                            createTime: item.createTime ? formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss') : ''
                        }
                    });
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-form-item__content {
    width: 50%;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    display: flex;
    white-space: nowrap;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>